import React, { FC } from "react";
import { styled } from "@mui/styles";
import { Typography, TypographyProps } from "@mui/material";

interface IStatusCellProps extends TypographyProps {}

const Cell = styled(Typography)(() => ({
  padding: "3px 16px",
  borderRadius: "3px",
  color: "white",
  fontWeight: "bold",
}));

const StatusCell: FC<IStatusCellProps> = (props) => {
  return <Cell {...props} />;
};

export default StatusCell;
